import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Container } from 'react-bootstrap';

import { useToast } from '../../hooks/toast';
import { usePerfil } from '../../hooks/perfil';
import { useAuth } from '../../hooks/auth';

import SelectSync, { IOption } from '../../components/SelectSync';

import Modal from '../../components/Modal';
import Button from '../../components/Button';

import getValidationErrors from '../../utils/getValidationErrors';
import ListaServicos, {
  IDadosLista,
  IServicoNFDTO,
  RefObject,
} from './ListaServicos';
import ServicoCadastro from './ServicoCadastro';

import { TIPO_USUARIO } from '../../utils/funcoes';

export interface IFormBusca {
  SerPerCodigo?: string;
}

const ServicoCadastroPagina: React.FC = () => {
  const listaRef = useRef<RefObject>(null);
  const history = useHistory();
  const { user } = useAuth();
  const { addToast } = useToast();
  const { optionsPerfil, buscaPerfil } = usePerfil();

  const [dadosForm, setDadosForm] = useState<IFormBusca | undefined>(undefined);

  const formRefBusca = useRef<FormHandles>(null);

  const [showModalCadastro, setShowModalCadastro] = useState(false);

  const [optionPerfil, setOptionsPerfil] = useState<IOption[]>([]);

  useEffect(() => {
    if (user.UsuTipo > TIPO_USUARIO.SUPERVISOR) {
      history.push('/sempermissao');
    }
  }, [history, user.UsuTipo]);

  useEffect(() => {
    async function loadPerfis(): Promise<void> {
      await buscaPerfil();
    }
    if (!optionsPerfil || Object.keys(optionsPerfil).length === 0) loadPerfis();
  }, [buscaPerfil, optionsPerfil]);

  useEffect(() => {
    try {
      setOptionsPerfil(optionsPerfil.optionPerfis);
    } catch (error) {
      addToast({
        title: 'Não foi possível buscar perfis',
        type: 'error',
      });
    }
  }, [addToast, optionsPerfil]);

  const handleSubmitBusca = useCallback(async (dados: IFormBusca) => {
    try {
      formRefBusca.current?.setErrors({});
      const schema = Yup.object().shape({
        SerPerCodigo: Yup.string(),
      });

      await schema.validate(dados, {
        abortEarly: false,
      });

      setDadosForm(dados);
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRefBusca.current?.setErrors(errors);
      }
    }
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleOnChangeVazio = useCallback(() => {}, []);

  const handleAdd = useCallback(
    async (
      dadosServico: IServicoNFDTO,
      dadosLista: IDadosLista,
      conCodigo: number | undefined,
    ) => {
      if (listaRef.current) {
        await listaRef.current.addRegistro(dadosServico, dadosLista, conCodigo);
        setShowModalCadastro(false);
      }
    },
    [],
  );

  return (
    <Container fluid className="mt-2">
      {showModalCadastro && (
        <Modal
          show={showModalCadastro}
          titulo="Cadastro de Serviços Para Nota Fiscal"
          handleFecharModal={() => setShowModalCadastro(false)}
          large
        >
          <ServicoCadastro addRegistro={handleAdd} />
        </Modal>
      )}
      <div className="bg-white border p-2 mb-2">
        <div className="d-flex justify-content-between mb-2">
          <h2 id="topoBusca">Serviços Nota Fiscal</h2>
          <div>
            <Button
              type="button"
              variant="success"
              onClick={() => {
                setShowModalCadastro(true);
              }}
            >
              Novo Serviço
            </Button>
          </div>
        </div>

        <Form ref={formRefBusca} onSubmit={handleSubmitBusca}>
          <div className="row no-gutters">
            <div className="col-md-2 mr-1">
              <SelectSync
                name="SerPerCodigo"
                label="Perfil"
                placeholder="Selecione"
                isClearable
                handleSelectChange={handleOnChangeVazio}
                options={optionPerfil}
              />
            </div>

            <div className="col-md-1">
              <div className="input-group-append mt-3">
                <Button type="submit" variant="secondary-outline">
                  BUSCAR
                </Button>
              </div>
            </div>
          </div>
        </Form>
      </div>

      <div className="bg-white border p-2">
        <ListaServicos ref={listaRef} dados={dadosForm} />
      </div>
    </Container>
  );
};

export default ServicoCadastroPagina;
